exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TeamRoster__container--2gqSU {\n  margin-top: 20px;\n}\n\n.TeamRoster__positionHeader--3GR-L {\n  background-color: #1e1f21;\n  font-size: 14px;\n  padding: 10px;\n  font-weight: 400;\n  color: #f9f9f9;\n  opacity: 0.65;\n}\n\n@media (min-width: 768px) {\n  .TeamRoster__positionContainer--1gCew span:nth-child(-n+2) {\n    border-top: none;\n  }\n}\n@media (max-width: 767px) {\n  .TeamRoster__positionContainer--1gCew span:first-child {\n    border-top: none;\n  }\n}", ""]);

// exports
exports.locals = {
	"container": "TeamRoster__container--2gqSU",
	"positionHeader": "TeamRoster__positionHeader--3GR-L",
	"positionContainer": "TeamRoster__positionContainer--1gCew"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };